'use client';

import { JobCard } from '@/components/job-card';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Skeleton } from './ui/skeleton';
import { getHomeJobs } from '@/actions/jobs-action';
import { useIsMobile } from '@/hooks/use-mobile';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';

interface JobCarouselProps {
    key: string;
    title: string;
    searchLink: string;
    tooltip?: string;
    basisClass?: string
}

export function JobCarousel({ data }: { data: JobCarouselProps }) {
    const { key, title, searchLink, tooltip, basisClass } = data
    const [isLoading, setIsLoading] = useState(true);
    const [jobs, setJobs] = useState<any[]>([]);
    const isMobile = useIsMobile();
    useEffect(() => {
        getHomeJobs(key, searchLink, isMobile ? 4 : 8).then(data => {
            const { docs, total } = data;
            setJobs([...docs]);
            setIsLoading(false);
        })
    }, [])
    if (!isLoading && !jobs?.length) {
        return null;
    }
    if (!!isLoading) {
        return <section className="mb-12">
            <div className="mb-4">
                <Skeleton className='h-10' />
            </div>
            <div className="grid grid-cols-1 gap-4">
                <Skeleton className='h-[200px]' />
            </div>
        </section>
    }
    return (
        <section className="mb-12">
            <div className='rounded-lg border bg-card text-card-foreground shadow-lg'>
                <div className='flex flex-col space-y-1.5 p-4 md:p-6 pb-2 md:pb-0'>
                    <div className="flex justify-between items-center mb-2">
                        <h2 className="text-[clamp(16px,4vw,24px)] font-bold font-headline">{title}</h2>
                        <Link href={searchLink} target='_blank' className='flex items-center whitespace-nowrap text-sm font-semibold text-primary hover:underline text-[clamp(11px,2vw,13px)]'>Xem tất cả <ChevronRight className="h-4 w-4" /></Link>
                    </div>
                </div>
                <div className='p-4 md:p-6 pt-0'>
                    <Carousel
                        opts={{
                            align: "start",
                            dragFree: true,
                        }}
                        className="w-full"
                    >
                        <CarouselContent>
                            {jobs.map((job, index) => (
                                <CarouselItem key={`${job.id}-${index}`}
                                    className={basisClass ?? `basis-[80%] sm:basis-1/2 lg:basis-1/4`}
                                >
                                    <div className="h-full">
                                        <JobCard job={job} showRecruiterName={true} variant="grid-item" showPostedTime={true} />
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>

                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </div>
            </div>
        </section>
    );
}
